import { LoggerTransportType } from '../../types';
import { pinoApplicationInsightsLogHandler } from './pinoApplicationInsightsLogHandler';
import { pinoConsoleLogHandler } from './pinoConsoleLogHandler';

/** Collection of log handlers for each transport type */
export const pinoGroupedLogHandlers = {
  [LoggerTransportType.APPLICATION_INSIGHTS]: pinoApplicationInsightsLogHandler,
  [LoggerTransportType.CONSOLE]: pinoConsoleLogHandler
};
//# sourceMappingURL=pinoGroupedLogHandlers.js.map